import * as bk01 from '../actions/bk01.actions';

export interface State {
    BK01_03;
}
export const initialState = {
    BK01_03: []
};

export function reducer(state = initialState, action: bk01.Actions) {
  switch (action.type) {
    case bk01.GO_TO_PAGE_BK01: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        ...data
      });
    }
    default:
      return state;
  }
}

function transformResponse(data) {
    return {
        BK01_03: firstFivePDFList(data)
    };
}

function firstFivePDFList(pdfArray) {
    const pdfReturnArray = [];
    pdfArray.forEach(e => {
        e.pdfFilesInfo.forEach(f => {
            if (pdfReturnArray.length < 5) {
                pdfReturnArray.push({
                    fileName: f.fileName,
                    filePath: f.filePath
                });
            }
        });
    });
    return pdfReturnArray;
}
